import React, { memo, useState, useCallback, FC } from 'react'
import * as S from './style'

type MenuItemTooltipProps = {
  titleMenu: string
  supTitle: string
  dataToolTip: string
  url: string
}

const MenuItemTooltip: FC<MenuItemTooltipProps> = ({ titleMenu, supTitle, dataToolTip, url }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggleTooltipVisibility = useCallback(() => setTooltipOpen(!tooltipOpen), [tooltipOpen])

  const handleLinkClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()
      setTooltipOpen(false)
      window.open(url, '_blank', 'noopener,noreferrer') // Open new tab with security
    },
    [url]
  )

  return (
    <>
      <div className="d-flex flex-column flex-start" id="menu-tooltip">
        <S.MenuItemLinkTooltip onClick={handleLinkClick}>
          <div className="flex items-center justify-center h-screen bg-gray-100">
            <div className="text-lg font-bold">
              {titleMenu}
              <i className="ml-3 fas fa-external-link-alt" />
            </div>
            <S.ItemTextSup>{supTitle}</S.ItemTextSup>
          </div>
        </S.MenuItemLinkTooltip>
      </div>
      <S.TooltipWrapper target="menu-tooltip" isOpen={tooltipOpen} toggle={toggleTooltipVisibility}>
        <div className="flex items-start text-left">{dataToolTip}</div>
      </S.TooltipWrapper>
    </>
  )
}

export default memo(MenuItemTooltip)
